export default env => {
  var warnings = new Set();
  return message => {
    if (process.env.NODE_ENV === env && !warnings.has(message)) {
      warnings.add(message);
      console.warn(message);
    }
  };
};